import { Entity } from "@/shared/Entity";

export class Person extends Entity {

    mainEmail() {

        if (!this.hasEmails()) {
            return null
        }

        for (const email of this.emails) {
            if (email.is_main) {
                return email.email
            }
        }

        return null
    }

    hasEmails() {
        return this.emails?.length > 0;
    }

    firstEmail() {
        return this.emails[0]?.email ?? null;
    }
}